import { notification } from 'antd'

notification.config({
  top: 48
})
